import React from 'react';

export default function ForgotPassword({ onBackToLogin }) {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4 pt-16">
      {/* Background gradient effects */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 -left-32 w-96 h-96 bg-[#FF7901]/20 rounded-full blur-[120px]" />
        <div className="absolute bottom-1/4 -right-32 w-96 h-96 bg-[#4A0A66]/30 rounded-full blur-[120px]" />
      </div>

      <div className="relative w-full max-w-md">
        {/* Logo/Brand */}
        <div className="text-center mb-8">
          <img 
            src="/calculator-logo.png" 
            alt="UnCloned® Offer Calculator"
            className="h-24 mx-auto"
          />
        </div>

        {/* Card */}
        <div className="relative">
          <div className="absolute -inset-0.5 bg-gradient-to-r from-[#FF7901] via-[#DF1283] to-[#4A0A66] rounded-2xl opacity-50 blur-sm" />
          
          <div className="relative bg-black/90 backdrop-blur-xl rounded-2xl p-8 border border-[#4A0A66]/30">
            <div className="text-center" data-testid="forgot-password-support">
              {/* Support Icon */}
              <div className="w-16 h-16 bg-[#FF7901]/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-[#FF7901]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              
              <h2 className="text-2xl font-bold text-white mb-4">Need Help Logging In?</h2>
              
              <p className="text-gray-300 mb-6 leading-relaxed">
                If you are having issues logging into your account, please send us a support ticket.
              </p>
              
              <a
                href="https://www.unclonedsupport.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="support-link"
                className="inline-block w-full py-3 px-4 bg-gradient-to-r from-[#FF7901] to-[#DF1283] text-white font-semibold rounded-lg hover:opacity-90 transition-all duration-200 shadow-lg shadow-[#FF7901]/25 text-center"
              >
                Submit Support Ticket
              </a>
              
              <p className="text-sm text-gray-500 mt-4">
                www.unclonedsupport.com
              </p>

              <div className="mt-6">
                <button
                  onClick={onBackToLogin}
                  data-testid="back-to-login"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  ← Back to Sign In
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center text-xs text-white/40 mt-8">
          <p>© 2025-2026 UnCloned® Media. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
}
